import { InputNumber } from 'antd';
import { useEffect, useState } from 'react';

interface MInputNumberProps {
  name: string;
  placeholder?: string;
  valueNum?: number;
  onChange: (value: number) => void;
}

const MInputNumber: React.FC<MInputNumberProps> = ({
  name,
  placeholder = '0',
  onChange,
  valueNum = 0,
}) => {
  const [value, setValue] = useState(valueNum);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <InputNumber
      className="trojan-input-number"
      min={0}
      name={name}
      placeholder={placeholder}
      controls={false}
      value={valueNum}
      addonAfter={<div onClick={() => setValue(value + 1)}>+</div>}
      addonBefore={<div onClick={() => setValue(value - 1)}>-</div>}
      onChange={(valueChange) => setValue(Number(valueChange))}
      onBlur={(event) => {
        setValue(Number(event.target.value));
      }}
    />
  );
};

export default MInputNumber;
